import { render, staticRenderFns } from "./VehicleDataTable.vue?vue&type=template&id=511d33ca"
import script from "./VehicleDataTable.vue?vue&type=script&lang=js"
export * from "./VehicleDataTable.vue?vue&type=script&lang=js"
import style0 from "./VehicleDataTable.vue?vue&type=style&index=0&id=511d33ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports